import React, { useEffect, useState } from 'react';

import LinkButton from '../../ui/link-button/link-button';

interface CountdownCardProps {
  imgClassName: string;
  showNavigationButton: boolean;
  titleClassName: string;
}

const CountdownCard: React.FC<CountdownCardProps> = ({
  imgClassName,
  showNavigationButton,
  titleClassName,
}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: '0',
    hours: '0',
    minutes: '0',
    seconds: '0',
  });

  useEffect(() => {
    const targetDate = new Date(Date.UTC(2025, 2, 6, 18, 0, 0)).getTime();
    const formatTime = (time: number) =>
      time < 10 ? `0${time}` : time.toString();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        setTimeLeft({ days: '0', hours: '0', minutes: '0', seconds: '0' });
        return;
      }

      setTimeLeft({
        days: formatTime(Math.floor(distance / (1000 * 60 * 60 * 24))),
        hours: formatTime(
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        ),
        minutes: formatTime(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        ),
        seconds: formatTime(Math.floor((distance % (1000 * 60)) / 1000)),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`ikea ${imgClassName} mb-5 bg-cover flex animate-fadeIn  items-center cursor-pointer flex-col rounded-xl bg-background-primary-light p-4 transition-all duration-200 hover:bg-background-secondary focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light animation-delay`}
    >
      <p
        className={`text-lg ${titleClassName} font-title text-neutral-grey-700 text-center text-white`}
      >
        A Trendy Thursday está quase a chegar!
      </p>
      <div className="grid grid-cols-4 gap-x-2 text-center">
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxl text-neutral-grey-700 text-white md:text-4xl">
            {timeLeft.days}
          </p>
          <p className="text-md text-white text-neutral-grey-700 tracking-wider">
            Dias
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxl text-neutral-grey-700 text-white md:text-4xl">
            {timeLeft.hours}
          </p>
          <p className="text-md text-white text-neutral-grey-700 tracking-wider">
            Horas
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxl text-neutral-grey-700 text-white md:text-4xl">
            {timeLeft.minutes}
          </p>
          <p className="text-md text-white text-neutral-grey-700 tracking-wider">
            Min
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxl text-neutral-grey-700 text-white md:text-4xl">
            {timeLeft.seconds}
          </p>
          <p className="text-md text-white text-neutral-grey-700 tracking-wider">
            Seg
          </p>
        </div>
      </div>
      {showNavigationButton && (
        <LinkButton
          to="./promocoes"
          variant="primary"
          className="w-[100%] text-center text-neutral-grey-700 mt-8"
        >
          {'Ver descontos e ofertas'}
        </LinkButton>
      )}
    </div>
  );
};

export default CountdownCard;
